import Kicker from './Kicker';
import SectionShell from './SectionShell';
import { useTranslation } from 'react-i18next';

function ComplianceSection() {
  const { t } = useTranslation();
  const compliance = [
    {
      eyebrow: t('compliance.items.i1_eyebrow'),
      title: t('compliance.items.i1_title'),
      copy: t('compliance.items.i1_copy'),
    },
    {
      eyebrow: t('compliance.items.i2_eyebrow'),
      title: t('compliance.items.i2_title'),
      copy: t('compliance.items.i2_copy'),
    },
    {
      eyebrow: t('compliance.items.i3_eyebrow'),
      title: t('compliance.items.i3_title'),
      copy: t('compliance.items.i3_copy'),
    },
    {
      eyebrow: t('compliance.items.i4_eyebrow'),
      title: t('compliance.items.i4_title'),
      copy: t('compliance.items.i4_copy'),
      dark: true,
    },
  ];

  return (
    <SectionShell id="compliance">
      <div>
        <Kicker>{t('compliance.kicker')}</Kicker>
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <h2 className="text-4xl font-black leading-tight sm:text-5xl">{t('compliance.title')}</h2>
          <p className="text-lg leading-8 text-slate-600">
            {t('compliance.body')}
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2">
          {compliance.map((item) => (
            <article
              key={item.title}
              className={`rounded border p-6 ${
                item.dark ? 'border-[#070b14] bg-[rgb(16_185_129)] text-white' : 'border-slate-200 bg-white'
              }`}
            >
              <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-emerald-500">{item.eyebrow}</p>
              <h3 className="mt-4 text-2xl font-black">{item.title}</h3>
              <p className={`mt-5 text-base leading-7 ${item.dark ? 'text-slate-100' : 'text-slate-600'}`}>
                {item.copy}
              </p>
            </article>
          ))}
        </div>
      </div>
      <div className="mt-10">
         <p className="text-sm font-semibold ">{t('compliance.footer')}</p>
      </div>
    </SectionShell>
  );
}

export default ComplianceSection;
